"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetFolderResponses = void 0;
const base_responses_1 = require("../base-responses");
var AssetFolderResponses;
(function (AssetFolderResponses) {
    class AssetFoldersListResponse extends base_responses_1.BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetFolderResponses.AssetFoldersListResponse = AssetFoldersListResponse;
    class AddAssetFoldersResponse extends base_responses_1.BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetFolderResponses.AddAssetFoldersResponse = AddAssetFoldersResponse;
    class ModifyAssetFoldersResponse extends base_responses_1.BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    AssetFolderResponses.ModifyAssetFoldersResponse = ModifyAssetFoldersResponse;
})(AssetFolderResponses = exports.AssetFolderResponses || (exports.AssetFolderResponses = {}));
//# sourceMappingURL=asset-folder-responses.js.map